<div class="confirm-dialog">
  <div class="dialog-header">
    <mat-icon class="header-icon">{{ data.icon }}</mat-icon>
    <h2 mat-dialog-title>{{ data.title }}</h2>
  </div>

  <mat-dialog-content>
    <p class="dialog-message">{{ data.message }}</p>
  </mat-dialog-content>

  <mat-dialog-actions align="center">
    <button mat-stroked-button
            type="button"
            (click)="onCancel()"
            class="cancel-btn">
      {{ data.cancelText }}
    </button>
    <button mat-raised-button
            type="button"
            [color]="data.destructive ? 'warn' : 'primary'"
            (click)="onConfirm()"
            class="confirm-btn">
      {{ data.confirmText }}
    </button>
  </mat-dialog-actions>
</div>
